import React, { PureComponent } from 'react';

import { ImageUploadGroup } from 'components/input/group';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

export default class BackgroundUpload extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.string,
    name: PropTypes.string
  };

  get images() {
    const { value } = this.props;

    return !isEmpty(value) ? [value] : [];
  }

  onImageChange = (items) => {
    const { onChange, name } = this.props;

    const target = { name, value: items[0] };

    onChange && onChange({ target });
  };

  render() {
    return (
      <ImageUploadGroup
        onItemsChange={this.onImageChange}
        images={this.images}
        {...this.props}
      />
    );
  }
}
